var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-bottom-bar elevation-10"},[_c('div',{staticClass:"fixed-bottom-bar-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }